import { mapState, mapActions } from "vuex";

export const authComputed = {
  ...mapState("auth", {
    user: (state) => state.user,
    hotel: (state) => state.hotel,
    rolePermission: (state) => state.rolePermission,
    loggedIn: (state) => state.status.loggedIn,
  }),
};

export const layoutComputed = {
  ...mapState("layout", {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader,
  }),
};

export const authMethods = mapActions("auth", [
  "login",
  "loginByOTP",
  "setHotel",
  "logout",
  "setRolePermission",
  "register",
]);

export const layoutMethods = mapActions("layout", [
  "changeLayoutType",
  "changeLayoutWidth",
  "changeLeftSidebarType",
  "changeTopbar",
  "changeLoaderValue",
]);

export const notificationMethods = mapActions("notification", [
  "success",
  "error",
  "clear",
]);
